export default __webpack_public_path__ + "static/media/Booknet.aee44393.png";